import React from 'react'

export const EmptyStatsRow = (
  {
    text
  }
) => {

  return <div className={`text-center bg-[#FEFEFE] text-Regular(16_18) font-bold py-[2rem]`}>{text}</div>
}